export default "__VITE_ASSET__9f92483d__"